import React, { useEffect, useState } from 'react';
import { UiComponents } from "@simulanisindia/ui";
import { format, addDays, startOfToday, isBefore, startOfDay, endOfDay, addMonths, addYears } from 'date-fns';
import moment from "moment";
import SimRadioButton from '../RadioButton';
import DateRangePicker from '../DateRangePicker';
import { CUSTOM_VALIDITY, MONTH_VALIDITY, YEAR_VALIDITY } from '../../Constant/constant';
import { convertNumberToWord } from '../../Utils/general';
import { useDispatch, useSelector } from 'react-redux';
import { setValidityData } from '../../Store/slice/subscriptionSlice';

const convertRange = (key, type) => {

    if (!key || !type) return null;
    let value = convertNumberToWord[key];
    const today = startOfDay(new Date());
    let futureDate;

    switch (type) {
        case 'day':
            futureDate = addDays(today, value - 1);
            break;
        case 'week':
            futureDate = addDays(today, value * 7 - 1);
            break;
        case 'month':
            futureDate = addMonths(today, value);
            futureDate = addDays(futureDate, -1);
            break;
        case 'year':
            futureDate = addYears(today, value);
            futureDate = addDays(futureDate, -1);
            break;
        case 'custom':
            futureDate = addDays(today, 0);
            break;
        default:
            throw new Error('Invalid type. Use "day", "week", "month", or "year".');
    }

    let endDate = endOfDay(futureDate);
    return [today, endDate];
};

const CreateValidity = () => {

    const dispatch = useDispatch();
    const { dateRange, validityType, validityKey } = useSelector(state => state.subscriptionSlice);

    const handleValidityTypeChange = (e) => {
        const [start, end] = convertRange("one", e.target.id);
        dispatch(setValidityData({
            dateRange: [start, end],
            type: e.target.id,
            key: "one"
        }));
    };

    const handleOptionSelect = (e) => {
        let type = validityType;
        const [start, end] = convertRange(e.target.id, type);
        dispatch(setValidityData({
            dateRange: [start, end],
            type: validityType,
            key: e.target.id
        }));
    };
    
    const handleUpdateDateRange = (dates) => {
        dispatch(setValidityData({
            dateRange: dates ? dates : [null, null],
            type: validityType,
            key: validityKey
        }));
    }

    return (
        <>
            <h5>Validity</h5>
            <p>Select the Skill Stream Module you want to assign to a group, user, and role  </p>
            <div className='org-validity'>
                <p>Validity</p>
                <div className='validity-time'>
                    <SimRadioButton label="Months" id={MONTH_VALIDITY} name="validityType" onChange={handleValidityTypeChange} checked={validityType === MONTH_VALIDITY} />
                    <SimRadioButton label="Years" id={YEAR_VALIDITY} name="validityType" onChange={handleValidityTypeChange} checked={validityType === YEAR_VALIDITY} />
                    <SimRadioButton label="Custom" id={CUSTOM_VALIDITY} name="validityType" onChange={handleValidityTypeChange} checked={validityType === CUSTOM_VALIDITY} />
                </div>
            </div>

            {(validityType === MONTH_VALIDITY) && (
                <div className='org-validity'>
                    <p>Months</p>
                    <div className='validity-time'>
                        <SimRadioButton label="1 Month" id='one' name="months" onChange={handleOptionSelect} checked={validityKey === 'one'} />
                        <SimRadioButton label="3 Months" id='three' name="months" onChange={handleOptionSelect} checked={validityKey === 'three'} />
                        <SimRadioButton label="9 Months" id='nine' name="months" onChange={handleOptionSelect} checked={validityKey === 'nine'} />
                    </div>
                </div>
            )}

            {(validityType === YEAR_VALIDITY) && (
                <div className='org-validity'>
                    <p>Year</p>
                    <div className='validity-time'>
                        <SimRadioButton label="1 Year" id='one' name="years" onChange={handleOptionSelect} checked={validityKey === 'one'} />
                        <SimRadioButton label="3 Year" id='three' name="years" onChange={handleOptionSelect} checked={validityKey === 'three'} />
                        <SimRadioButton label="9 Year" id='nine' name="years" onChange={handleOptionSelect} checked={validityKey === 'nine'} />
                    </div>
                </div>
            )}

            {(dateRange[0] && dateRange[1] && [MONTH_VALIDITY, YEAR_VALIDITY].includes(validityType)) &&
                <>
                    <p> start: {moment(dateRange[0]).format('ll')} </p>
                    <p>end: {moment(dateRange[1]).format('ll')}</p>
                </>
            }

            {(validityType === CUSTOM_VALIDITY) && (
                <div className='org-validity'>
                    <p>Custom</p>
                    <div className='validity-time'>
                        <DateRangePicker dateRange={dateRange} setDateRange={handleUpdateDateRange} />
                    </div>
                </div>
            )}
        </>
    )
}

export default CreateValidity